import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux'
import './FilterMenu.scss';
import Separator from './Separator';
import CategoriaBtn from './CategoriaBtn';
import Slidebar from './Slidebar'
import { ColorChecker } from './ColorChecker'
import { setSelectedForma, setSelectedCollection, setSelectedCategoryName, setSelectedCategory, pushFilters, popFilter, setSelectedColor, setSelectedHole, setSelectedMinMaxDiameter, setSelectedCharacteristic, setSelectedNew, setPaginationState } from '../actions'
import { FormasFilter } from '../filters/FormasFilter'
import { ColoresFilter } from '../filters/ColoresFilter'
import { formasUnique } from '../hooks/formas'
import { coloresUnique } from '../hooks/colores'
import { getMinMaxDiameter } from '../hooks/minMaxDiameter'
import { CollectionFilter } from '../filters/CollectionFilter'
import { DiameterFilter } from '../filters/DiameterFilter'
import FiltersActive from './FiltersActive';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { HoleFilter } from '../filters/HoleFilter';
import { characteristicsUnique } from '../hooks/characteristics';
import { CharacteristicFilter } from '../filters/CharacteristicFilter';
import { categoriesAllParse, categoriesUnique } from '../hooks/categoriesUnique';
import { CategoryFilter } from '../filters/CategoryFilter';
import { HolesUnique } from '../hooks/holeProducts';
import { scrollBodyTop } from '../hooks/scrollPosition';
import { useNavigate } from 'react-router-dom';
import { collectionsUnique } from '../hooks/collectionsUnique';
import { newProducts } from '../hooks/newProducts';
import { NewFilter } from '../filters/NewFilter';
import { BRANDCHOSEN } from '../hooks/config';
import _ from 'lodash';

const FilterMenu = (props) => {
    const navigate = useNavigate(); 
    const [minMaxDiameter, setMinMaxDiameter] = useState(null)
    const [categories, setCategories] = useState([])
    const [formas, setFormas] = useState([])
    const [characteristics, setCharacteristics] = useState([])
    const [holesTypes, setHolesTypes] = useState([])
    const [collections, setCollections] = useState([])
    const [newProucts, setNewProucts] = useState(false)
    const [colors, setColors] = useState([])

    useEffect(() => {
        if (props.productsCategory && props.productsCategory.length > 0) {
            const minMax = getMinMaxDiameter(props.productsCategory)
            setMinMaxDiameter(minMax)

            const formas = formasUnique(props.productsCategory)
            setFormas(formas)

            const colores = coloresUnique(props.productsCategory, props.allColors)
            setColors(colores)

            const characteristics = characteristicsUnique(props.productsCategory)
            setCharacteristics(characteristics)

            const holesType = HolesUnique(props.productsCategory)
            setHolesTypes(holesType)

            const collections = collectionsUnique(props.productsCategory)
            setCollections(collections)

            const newProductsResult = newProducts(props.productsCategory)
            setNewProucts(newProductsResult)

            if (props.productsTable === 'allProductsOutlet' || props.productsTable === 'allProductsExpositors' || props.productsTable === 'allProductsSearch' || props.productsTable === 'allProductsPromoA' || props.productsTable === 'allProductsPromoB' || props.productsTable === 'allProductsPromoC' || props.productsTable === 'allProductsImplantations') {
                const categories = categoriesUnique(props.productsCategory, props.categoriesAll)
                setCategories(categories)
            } else {
                const categories = categoriesAllParse(props.categoriesAll)
                setCategories(categories)
            }
        }
    }, [props.productsCategory, props.filters])

    const handleCategoryClick = async (category) => {
        const categoryAllData = _.filter(props.categoriesAll[BRANDCHOSEN], ['Name', category.nombre])[0]
        const categoryFilter = new CategoryFilter(category.nombre)
        props.setSelectedCategoryName(category.nombre)
        if (props.productsTable === 'allProducts') {
            await props.setSelectedCategory({
                categoryId: categoryAllData.ID,
                subtitle: categoryAllData.Name,
                img: categoryAllData.ImgBanner,
                selectedCollection: ''
            })
        }
        await props.pushFilters(categoryFilter)
        scrollBodyTop()
        const url = `/categoria/${categoryAllData.ID}`
        navigate(url)
        props.setPaginationState(1)
    }

    const handleColeccionClick = (collection) => {
        const collectionFilter = new CollectionFilter(collection)
        props.pushFilters(collectionFilter)
        props.setSelectedCollection(collection)
        props.setPaginationState(1)
    }

    const handleFormaClick = (forma) => {
        const formasFilter = new FormasFilter(forma)
        props.pushFilters(formasFilter)
        props.setSelectedForma(forma)
        props.setPaginationState(1)
    }

    const handleDiameterClick = (minMaxDiameter) => {
        const diametroFiltro = new DiameterFilter(minMaxDiameter)
        props.pushFilters(diametroFiltro)
        props.setSelectedMinMaxDiameter(minMaxDiameter)
        props.setPaginationState(1)
    }

    const handleColorClick = (color) => {
        const coloresFilter = new ColoresFilter(color)
        props.pushFilters(coloresFilter)
        props.setSelectedColor(color)
        props.setPaginationState(1)
    }

    const handleHoleClick = (hole) => {
        const holeFilter = new HoleFilter(hole)
        props.pushFilters(holeFilter)
        props.setSelectedHole(hole)
        props.setPaginationState(1)
    }

    const handleNewClick = () => {
        const newFilter = new NewFilter('Nuevo producto')
        props.pushFilters(newFilter)
        props.setSelectedNew('Nuevo')
        props.setPaginationState(1)
    }

    const handleCharacteristicClick = (characteristic) => {
        let characteristics = _.cloneDeep(props.selectedCharacteristic)
        const indice = _.findIndex(props.selectedCharacteristic, el => {
            return el === characteristic
        })
        if (indice === -1) {
            characteristics = characteristics.concat(characteristic);
        }
        const characteristicFilter = new CharacteristicFilter(characteristics)
        props.pushFilters(characteristicFilter)
        props.setSelectedCharacteristic(characteristics)
        props.setPaginationState(1)
    }

    return (
        <div className="tienda-menu-container">
            <FiltersActive />
            <Separator />

            {categories.length >= 2 &&
                <React.Fragment>
                    <Accordion>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <div className="title">Categorías</div>
                        </AccordionSummary>
                        <AccordionDetails>
                            {Array.isArray(categories) && categories.map((category, index) => (
                                <div
                                    key={index}
                                    onClick={() => handleCategoryClick(category)}>
                                    {category.nombre === 'Nuevo' ?
                                        <CategoriaBtn
                                            active={props.selectedCategoryName === category.nombre} nombre="Novedades" />
                                        :
                                        <CategoriaBtn
                                            active={props.selectedCategoryName === category.nombre} nombre={category.nombre} />
                                    }
                                </div>
                            ))}
                        </AccordionDetails>
                    </Accordion>
                    <Separator />
                </React.Fragment>
            }

            {collections.length > 2 &&
                <React.Fragment>
                    <Accordion>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <div className="title">Coleccion</div>
                        </AccordionSummary>
                        <AccordionDetails>
                            {Array.isArray(collections) && collections.map((collection, index) => (
                                <div
                                    key={index}
                                    onClick={() => handleColeccionClick(collection)}>
                                    <CategoriaBtn
                                        active={props.selectedCollection === collection} nombre={collection} />
                                </div>
                            ))}
                        </AccordionDetails>
                    </Accordion>
                    <Separator />
                </React.Fragment>
            }

            {Array.isArray(formas) && formas.length > 1 &&
                <React.Fragment>
                    <Accordion>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <div className="title"> Forma</div>
                        </AccordionSummary>
                        <AccordionDetails>
                            {formas.map(forma => (
                                <div
                                    key={forma.nombre}
                                    onClick={() => handleFormaClick(forma.nombre)}>
                                    <CategoriaBtn active={props.selectedForma === forma.nombre} key={forma.nombre} nombre={forma.nombre} />
                                </div>
                            ))}
                        </AccordionDetails>
                    </Accordion>
                    <Separator />
                </React.Fragment>
            }

            {props.productsTable !== 'allProductsExpositors' && minMaxDiameter !== null && minMaxDiameter.min !== minMaxDiameter.max &&
                <React.Fragment>
                    <Accordion>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <div className="title">Diámetro</div>
                        </AccordionSummary>
                        <AccordionDetails>
                            {minMaxDiameter !== null &&
                                <Slidebar
                                    valuesMinMax={[minMaxDiameter.min, minMaxDiameter.max]}
                                    onClick={handleDiameterClick}
                                />
                            }
                        </AccordionDetails>
                    </Accordion>
                    <Separator />
                </React.Fragment>
            }


            {colors.length > 1 &&
                <React.Fragment>
                    <Accordion>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <div className="title">Color</div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <ColorChecker
                                colors={colors}
                                onClick={handleColorClick}
                            />
                        </AccordionDetails>
                    </Accordion>
                    <Separator />
                </React.Fragment>
            }

            {Array.isArray(characteristics) && characteristics.length > 1 &&
                <React.Fragment>
                    <Accordion>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <div className="title">Caracteristicas</div>
                        </AccordionSummary>
                        <AccordionDetails>
                            {Array.isArray(characteristics) && characteristics.map(characteristic => (
                                <div key={characteristic} onClick={() => handleCharacteristicClick(characteristic)}>
                                    <CategoriaBtn key={characteristic} active={_.includes(props.selectedCharacteristic, characteristic)} nombre={characteristic} />
                                </div>
                            ))}
                        </AccordionDetails>
                    </Accordion>
                    <Separator />
                </React.Fragment>
            }

            {Array.isArray(holesTypes) && holesTypes.length > 1 && props.productsTable !== 'allProductsExpositors' &&
                <React.Fragment>
                    <Accordion>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <div className="title">Agujero</div>
                        </AccordionSummary>
                        <AccordionDetails>
                            {
                                Array.isArray(holesTypes) && holesTypes.map(type => (
                                    <div onClick={() => handleHoleClick(type)} key={type}>
                                        <CategoriaBtn nombre={type} active={props.selectedHole === type} />
                                    </div>
                                ))
                            }
                        </AccordionDetails>
                    </Accordion>
                    <Separator />
                </React.Fragment>
            }

            {newProucts === true && props.headerData.subtitle !== 'Nuevo' &&
                <React.Fragment>
                    <Accordion>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <div className="title">Novedades</div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div onClick={handleNewClick} key={'nuevo'}>
                                <CategoriaBtn nombre={'Novedades'} active={props.selectedNew === 'Nuevo'} />
                            </div>
                        </AccordionDetails>
                    </Accordion>
                    <Separator />
                </React.Fragment>
            }
        </div >
    )
}

const mapDispatchToProps = {
    setSelectedForma,
    pushFilters,
    popFilter,
    setSelectedColor,
    setSelectedHole,
    setSelectedCollection,
    setSelectedCategoryName,
    setSelectedCategory,
    setSelectedMinMaxDiameter,
    setSelectedCharacteristic,
    setSelectedNew,
    setPaginationState
}

const mapStateToProps = state => state

export default connect(mapStateToProps, mapDispatchToProps)(FilterMenu)